<div class="pdf-wrapper">
    <dsn-button-squared
        [label]="'Baixar'"
        [type]="'secondary'"
        [icon]="'fa-solid fa-download'"
        [disabled]="false"
        [matTooltip]="'Baixar PDF'"
        (click)="pdfService.printAgain()"
        style="position: fixed; top: 26px; right: 36px; z-index: 100"
        class="pdf-button-download"
        [disabled]="loading"
    ></dsn-button-squared>
    <div class="pdf-container">
        @if (
            (reportPreferenceService.viewBench && hasBenchmarking) ||
            reportPreferenceService.viewPeformance
        ) {
            <div class="pdf-page">
                <header class="pdf-header">
                    <app-report-header
                        [options]="report?.options"
                        [reportName]="report?.props?.name"
                        [company]="company"
                    ></app-report-header>
                </header>
                <main class="pdf-content">
                    @if (reportPreferenceService.viewBench) {
                        <section class="pdf-section">
                            <dsn-expand-collapse
                                [isExpanded]="true"
                                [customIcon]="
                                    'images/icons/benchmarking-icon.svg'
                                "
                                [label]="'Benchmarking'"
                                [type]="'default'"
                                [style.display]="
                                    hasBenchmarking ? 'block' : 'none'
                                "
                                [fontSize]="'small'"
                                [disabled]="true"
                            >
                                <app-report-beachmarking-section
                                    [report]="report"
                                    [company]="company"
                                    [loading]="loading"
                                    [pdfMode]="true"
                                    [previewMode]="false"
                                    [locked]="true"
                                    (handleBenchmarkingDataLoaded)="
                                        onBenchmarkingDataLoaded($event)
                                    "
                                ></app-report-beachmarking-section>
                                <div
                                    fxLayout="row"
                                    style="
                                        margin-left: 14px;
                                        padding-bottom: 16px;
                                    "
                                >
                                    <dsn-button-link
                                        [label]="'Recurso exclusivo do digital'"
                                        [type]="'default'"
                                        [icons]="[
                                            'fa-solid fa-lock',
                                            'fa-solid fa-external-link-alt'
                                        ]"
                                        [href]="pdfService.linkDigital"
                                    ></dsn-button-link>
                                </div>
                            </dsn-expand-collapse>
                        </section>
                    }
                    @if (reportPreferenceService.viewPeformance) {
                        <section class="pdf-section">
                            <dsn-expand-collapse
                                [isExpanded]="true"
                                [customIcon]="
                                    'images/icons/performance-icon.svg'
                                "
                                [label]="'Performance'"
                                [type]="'default'"
                                [fontSize]="'small'"
                                [disabled]="true"
                            >
                                @defer (when !loading) {
                                    <app-report-performance
                                        [visualizations]="
                                            report?.visualizations
                                        "
                                        [options]="report?.options"
                                        [company]="company"
                                        [report]="report"
                                        [pdfMode]="true"
                                        [linkDigital]="pdfService.linkDigital"
                                    ></app-report-performance>
                                }
                            </dsn-expand-collapse>
                        </section>
                    }
                </main>
                <footer class="pdf-footer">
                    <app-report-pdf-footer
                        [linkDigital]="pdfService.linkDigital"
                        [type]="'full'"
                    >
                    </app-report-pdf-footer>
                </footer>
            </div>
        }
        @for (page of pdfService.indexPages; track $index) {
            <div class="pdf-page">
                @if (
                    !(
                        (reportPreferenceService.viewBench &&
                            hasBenchmarking) ||
                        reportPreferenceService.viewPeformance
                    ) && $index === 0
                ) {
                    <header class="pdf-header">
                        <app-report-header
                            [options]="report?.options"
                            [reportName]="report?.props?.name"
                            [company]="company"
                        ></app-report-header>
                    </header>
                }
                <main class="pdf-content">
                    <section class="pdf-section">
                        <app-report-pdf-index
                            [visualizations]="page.visualizations"
                        ></app-report-pdf-index>
                    </section>
                </main>
                @if (
                    !(
                        (reportPreferenceService.viewBench &&
                            hasBenchmarking) ||
                        reportPreferenceService.viewPeformance
                    ) && $index === 0
                ) {
                    <footer class="pdf-footer">
                        <app-report-pdf-footer
                            [linkDigital]="pdfService.linkDigital"
                            [type]="'full'"
                        >
                        </app-report-pdf-footer>
                    </footer>
                }
            </div>
        }

        @for (page of tableBudgetPages; track $index) {
            <div
                class="pdf-page"
                [class.pdf-page--break]="
                    ($index !== 0 && !reportPreferenceService.viewBench) ||
                    reportPreferenceService.viewBench ||
                    reportPreferenceService.viewPeformance ||
                    ($index !== 0 && !reportPreferenceService.viewPeformance)
                "
            >
                <header class="pdf-header">
                    @if (
                        (!reportPreferenceService.viewBench ||
                            !hasBenchmarking) &&
                        $index === 0
                    ) {
                        <header class="pdf-header">
                            <app-report-header
                                [options]="report?.options"
                                [reportName]="report?.props?.name"
                                [company]="company"
                            ></app-report-header>
                        </header>
                    }
                    <app-report-toolbar
                        [report]="report"
                        [options]="report?.options"
                        [company]="company"
                        [loading]="loading"
                        [scenarios]="report?.scenarios"
                        [budgets]="report?.budgets"
                        [projections]="report?.projections"
                        [dropdowns]="{
                            period: false,
                            comparation: false
                        }"
                        [pdf]="true"
                        [linkDigital]="pdfService.linkDigital"
                    ></app-report-toolbar>
                </header>
                <main class="pdf-content">
                    <section class="pdf-section">
                        <app-table-budget
                            [loading]="loading"
                            [options]="report?.options"
                            [pdfMode]="true"
                            [dates]="page.dates"
                            [indexInterval]="page.indexInterval"
                            [company]="company"
                        ></app-table-budget>
                    </section>
                </main>

                @if (
                    $index === tableBudgetPages.length - 1 ||
                    (!reportPreferenceService?.viewBench && $index === 0)
                ) {
                    <footer class="pdf-footer">
                        <app-report-pdf-footer
                            [linkDigital]="pdfService.linkDigital"
                            [type]="'full'"
                        >
                        </app-report-pdf-footer>
                    </footer>
                }
            </div>
        }
    </div>
</div>
